
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[language]/[location]",
      function () {
        return require("private-next-pages/[language]/[location]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[language]/[location]"])
      });
    }
  